import React from "react";
import { TeamWithScores } from "../../../apis/types";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { TCText } from "../../../components/tcText/TCText";
import { Colors } from "../../../utils/colors";

type props = {
  team?: TeamWithScores;
  isCurrentUserTeam: boolean;
};

export const TeamPlayersProfile: React.FC<props> = ({
  team,
  isCurrentUserTeam,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        gap: 8,
      }}>
      <UserAvatar
        avatar={{
          image: team?.playerA.playerImageUrl ?? "",
          name: team?.playerA.playerName ?? "",
        }}
        size={32}
      />
      <UserAvatar
        avatar={{
          image: team?.playerB.playerImageUrl ?? "",
          name: team?.playerB.playerName ?? "",
        }}
        size={32}
        style={{ marginLeft: -10 }}
      />
      <div>
        <TCText
          value={team?.playerA.playerName ?? ""}
          // numberOfLines={1}
          style={{
            fontSize: 10,
            fontWeight: isCurrentUserTeam ? 600 : 500,
            color: isCurrentUserTeam ? Colors.green : Colors.grey,
            //   overflow: "hidden",
            //   textOverflow: "ellipsis",
          }}
        />
        <TCText
          value={team?.playerB.playerName ?? ""}
          style={{
            fontSize: 10,
            fontWeight: isCurrentUserTeam ? 600 : 500,
            color: isCurrentUserTeam ? Colors.green : Colors.grey,
            marginTop: -3,
          }}
        />
      </div>
    </div>
  );
};
